<template>
  <div class="page">
    <!-- 验证域名 -->
    <template v-if="step === 0">
      <div class="bj-search-section" style="margin-top: 40px">
        <div class="bj-search-row">
          <div class="item">
            <div class="name">请填写您要转出的域名：</div>
            <Input
              class="bj-input-26262A bj-input-h45"
              v-model="form.domainName"
              placeholder="请输入搜索的域名名称"
              style="width: 300px"
              clearable
            />
            <Button
              style="margin-left: 20px"
              :loading="step1Loading"
              type="primary"
              class="bj-search-btn-F85A36"
              @click="stepNext()"
              >下一步</Button
            >
          </div>
        </div>
      </div>
      <div class="tips">
        <h4 class="title">
          域见未来域名<span style="color: #f85a36">转出条件</span>
        </h4>
        <ul class="no">
          <li class="def">域名注册满60天后可以办理转移注册商。</li>
          <li class="def">cn/top/wang域名距离到期前16天以上可以办理转移。</li>
          <li class="def">
            国际域名在续费后60天内转入到新注册商，可能续费不会增加一年，建议等待续费满60天后再办理转移。
          </li>
          <li class="def">
            转移密码有效时间为7天，请在有效期内操作转移，如过期不操作自动视为放弃转移。
          </li>
          <li class="def">
            设置了隐私保护的域名，获取转移密码前要先取消隐私保护。
          </li>
          <li class="def">
            国内部分注册商(万网、新网等)及其代理不能在线过户域名，转入后域名信息不能自动变更或通过在线过户变更，请谨慎操作。
          </li>
          <li class="def">
            获取转移密码到邮箱里，可能会由于网络延迟或邮件过滤设置等原因，导致邮件延迟或收不到，建议可以垃圾邮件中查看下，或更改邮件过滤设置。
          </li>
          <li class="def">
            按照上游注册局的规则，域名转出过程需要5天时间，此时间是指客户在域名转入注册商提交正确转移密码后，且中途未对域名转出进行拒绝情况下需要的时间。
          </li>
          <li class="warn">
            若有任何疑问，请联系域名专员协助解决。联系电话：400-076-3676
            邮箱：service@domainfuture.cn
          </li>
          <li class="warn">
            <span style="cursor: pointer" @click="transferRulesModel">《域名转移服务协议》</span>
          </li>
        </ul>
      </div>
    </template>
    <!-- 验证手机号 -->
    <div v-show="step === 1">
      <div class="nos">
        国际域名续费60天内转入到新注册商，可能会产生“续费掉年”现象，请谨慎操作!
      </div>
      <div class="content">
        <navStepList
          :value="navStepList"
          :current="navStepCurrent"
          :lineWidth="40"
        ></navStepList>
        <div class="section">
          <div class="title">为了保障您的域名安全，我们需要验证您的信息</div>
          <div v-if="checkType === 0" class="bj-rows">
            <div class="name">手机号码：</div>
            <div>
              {{ mobilePhone }}
              <span v-if="user.email && user.email.length > 0 && !smsBtnDisabled" style="color: #f85a36; cursor: pointer; margin-left: 20px; margin-right: 20px" @click="checkTypeMethod(1)">邮箱验证</span>
              <span style="color: #f85a36"
                >若您的手机号码已停用，请联系在线客服。</span
              >
            </div>
          </div>
          <div v-if="checkType === 1" class="bj-rows">
            <div class="name">邮箱：</div>
            <div>
              {{ user.email }}
              <span v-if="user.mobile && user.mobile.length > 0 && !smsBtnDisabled" style="color: #f85a36; cursor: pointer; margin-left: 20px" @click="checkTypeMethod(0)">手机号码验证</span>
            </div>
          </div>
          <div class="bj-rows" style="margin-top: 20px">
            <div class="name">验证码：</div>
            <Input
              class="bj-input-26262A bj-input-h45"
              placeholder="请输入验证码"
              clearable
              v-model="form.code"
              style="width: 200px"
            >
            </Input>
            <smsBtn
              ref="smsBtn"
              height="45px"
              @tap="getCodeEvent"
              @change="onSmsBtnChange"
              style="width: 120px; margin-left: 20px"
            ></smsBtn>
          </div>
          <div style="margin-top: 40px; margin-left: 140px">
            <Button
              :loading="step2Loading"
              type="primary"
              class="bj-search-btn-F85A36"
              @click="stepNext2()"
              >下一步</Button
            >
            <Button
              class="bj-border-F85A36"
              style="margin-left: 40px"
              @click="goBak()"
              >返回</Button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 核对邮箱 -->
    <template v-if="step === 2">
      <div class="nos">
        国际域名续费60天内转入到新注册商，可能会产生“续费掉年”现象，请谨慎操作!
      </div>
      <div class="content">
        <navStepList
          :value="navStepList"
          :current="navStepCurrent"
          :lineWidth="40"
        ></navStepList>
        <div class="section">
          <div class="title">为了保障您的域名安全，我们需要验证您的信息</div>
          <div class="bj-rows" style="margin-top: 20px">
            <div class="name">转出的域名：</div>
            <div>{{ form.domainName }}</div>
          </div>
          <div class="bj-rows" style="margin-top: 20px">
            <div class="name">转移码接收邮箱：</div>
            <div>{{ email }}</div>
          </div>
          <div style="margin-top: 20px; margin-left: 140px">
            <Button
              :loading="step3Loading"
              type="primary"
              class="bj-search-btn-F85A36"
              @click="stepNext3()"
              >获取转移码</Button
            >
            <Button
              class="bj-border-F85A36"
              style="margin-left: 40px"
              @click="goBak()"
              >返回</Button
            >
          </div>
        </div>
      </div>
    </template>
    <!-- 域名转移服务协议 -->
    <rule-modal
        :show.sync="transferRulesModelShow"
        :content="transferRulesContent"
        :title="transferRulesTitle"
    ></rule-modal>
  </div>
</template>

<script>
import navStepList from "components/navStepList";
import smsBtn from "components/smsBtn.vue";
import { smsSend } from "api/user.js";
import {
  transferOutCheckDomain,
  transferOutCheckMobile,
  transferOutTransferCode,
} from "api/domain.js";
import ruleModal from "components/ruleModal.vue";
import transferRules from "assets/rule/transferOutRules";
import { mapState } from "vuex";

export default {
  name: "transferout",
  components: {
    navStepList,
    smsBtn,
    ruleModal,
  },
  data() {
    return {
      step: 0, // 0 查询域名 1 验证手机 2 发送转移码
      navStepList: ["验证手机", "核对邮箱", "等待邮件确认", "域名转出成功"],
      navStepCurrent: 0,
      step1Loading: false,
      step2Loading: false,
      step3Loading: false,
      transferCode: "",
      email: "",
      mobilePhone: "",
      form: {
        domainName: "",
        code: "",
      },
      checkType: 0,
      smsBtnDisabled: false,
      // 域名转移服务协议
      transferRulesModelShow: false,
      transferRulesContent: "",
      transferRulesTitle: "",
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  created() {
    if (this.user.mobile != null && this.user.mobile.length > 0) {
      this.checkType = 0
    } else {
      this.checkType = 1
    }
  },
  methods: {
    onSmsBtnChange(val) {
      this.smsBtnDisabled = val;
    },
    checkTypeMethod(type) {
      this.checkType = type
      this.$refs.smsBtn.reset();
    },
    // 域名管理系统域名push服务协议
    transferRulesModel() {
      this.transferRulesModelShow = true;
      if (!this.transferRulesContent) {
        this.transferRulesContent = transferRules.content;
        this.transferRulesTitle = transferRules.title;
      }
    },
    // 发送验证码
    getCodeEvent(callback) {
      smsSend(this.checkType)
        .then((res) => {
          if (res.code === 200 && res.result) {
            callback(true);
          }
        })
        .catch(() => {
          this.$refs.smsBtn.reset();
        });
    },
    // 检测域名
    async stepNext() {
      try {
        if (!this.form.domainName) {
          this.$Message.warning("请输入域名！");
          return false;
        }
        let params = {
          domainName: this.form.domainName,
        };
        this.step1Loading = true;
        const { code, data, result } = await transferOutCheckDomain(params);
        this.step1Loading = false;
        if (code === 200 && result) {
          this.navStepCurrent = 0;
          this.step = 1;
          this.transferCode = data.code;
          this.email = data.email;
          this.mobilePhone = data.sj;
          this.form.domainName = data.ym;
          this.$nextTick(() => {
            this.$refs.smsBtn.getCodeEvent();
          });
        }
      } catch (error) {
        this.step1Loading = false;
        console.log(error);
      }
    },
    // 检测手机号
    async stepNext2() {
      try {
        if (!this.transferCode) {
          this.$Message.warning("没有权限进行此次操作！");
          return;
        }
        if (this.form.code == null || this.form.code === "") {
          this.$Message.warning("请输入短信验证码！");
          return;
        }
        let params = {
          msg: this.form.code,
          verify: this.transferCode,
          type: this.checkType,
        };
        this.step2Loading = true;
        const { code, data, result } = await transferOutCheckMobile(params);
        this.step2Loading = false;
        if (code === 200 && result) {
          this.transferCode = data.code;
          this.email = data.email;
          this.mobilePhone = data.sj;
          this.form.domainName = data.ym;
          this.navStepCurrent = 1;
          this.step = 2;
          this.$refs.smsBtn.reset();
        }
      } catch (error) {
        this.step2Loading = false;
        this.$refs.smsBtn.reset();
        console.log(error);
      }
    },
    // 发送转移码
    async stepNext3() {
      try {
        if (!this.transferCode) {
          this.$Message.warning("没有权限进行此次操作！");
          return;
        }
        let params = {
          verifyCode: this.transferCode,
        };
        this.step3Loading = true;
        const { code, result } = await transferOutTransferCode(params);
        this.step3Loading = false;
        if (code === 200 && result) {
          this.$Message.success(
            "域名转出申请已经提交，请等待我司域名转移专员为您人工审核处理！"
          );
          this.$router.replace("/my/transferout/record");
        }
      } catch (error) {
        this.step3Loading = false;
        console.log(error);
      }
    },
    // 返回
    goBak() {
      this.step = 0;
      this.transferCode = "";
      this.email = "";
      this.mobilePhone = "";
      this.form.domainName = "";
      this.navStepCurrent = 0;
      this.smsBtnDisabled = false;
      if (this.$refs.smsBtn) {
        this.$refs.smsBtn.reset();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.bj-search-section {
  background-color: #28292c;
  padding: 30px 28px;
  border-radius: 6px;
  margin-top: 40px;
  .bj-search-row {
    display: flex;
    .item {
      display: flex;
      align-items: center;
      .name {
        color: #fff;
      }
    }
  }
}
.tips {
  margin: 40px 0px 0;
  padding: 20px 0px;
  color: #fff;
  .title {
    font-size: 18px;
  }
}
.no {
  margin-left: 20px;
  margin-top: 20px;
  .def {
    line-height: 35px;
    color: #737577;
  }
  .warn {
    color: #ff5c35;
    line-height: 50px;
  }
}
.tips-warn {
  padding: 28px 50px;
  border-radius: 8px;
  color: #333333;
  font-size: 14px;
  background-color: #e9effd;
  border: 1px solid #3992e9;
  display: flex;
  align-items: center;
  .icon {
    margin-right: 20px;
    width: 20px;
    height: 19px;
  }
}
.nos {
  background-color: #28292c;
  border-radius: 6px;
  padding: 15px 23px;
  margin: 20px 0 40px;
  color: #fff;
}
.section {
  margin-top: 40px;
  background-color: #28292c;
  border-radius: 6px;
  text-align: center;
  padding: 30px;
  color: #fff;
  .title {
    padding: 20px 0;
  }
}
</style>
